export default __webpack_public_path__ + "static/media/charity_gold.1019bd8a.svg";